import React from "react";
import './Logo.css';
export const Logo = () => {
    return <div className='brand'>
        <img src='/logo.svg' className='brand__logo' width='30' height='30' />
        <div className='brand__name'><span className='color-remote-wise'>Remote</span> Wise</div>
    </div>
}